// Fecho da conversa: o resumo do que o VITA entendeu, o consentimento e a
// porta para a avaliação corporal.
//
// O CARD "SEU PLANO" é resumo, não promessa: ele repete o que a PESSOA
// respondeu. O plano de verdade é gerado depois, em segundo plano, e
// aparece nos dois botões flutuantes da esquerda.
//
// NÃO HÁ CAIXA DE CONSENTIMENTO AQUI, e é de propósito. Os Termos de Uso
// aceitos no cadastro têm a seção 8 inteira — "Consentimento Informado —
// VitAI (Plano por IA)" — dizendo que o plano é informativo, que não
// substitui orientação profissional e que o usuário declara com veracidade
// suas restrições. A Política de Privacidade declara a base legal (Art. 11,
// I) e lista o subprocessador. Pedir de novo aqui seria uma segunda parede
// para um aceite que já existe, registrado com data, hora e versão.
//
// O que o app continua fazendo é gravar o REGISTRO de que o plano foi
// solicitado (`saveVitAIConsent`), porque a seção 8 fala em registro por
// solicitação. Isso é trilha de auditoria, não pergunta — ver FormsObjetivo.

import React, { useEffect, useState } from "react";

import { MUSCULOS, OBJETIVOS } from "../conversa.js";
import s from "./StepConclusion.module.scss";

const nomeDoDia = { Seg: "Seg", Ter: "Ter", Qua: "Qua", Qui: "Qui", Sex: "Sex", Sab: "Sáb", Dom: "Dom" };

function resumoDoPlano(a = {}) {
  const dias = Array.isArray(a.TRAINING_DAYS) ? a.TRAINING_DAYS : [];
  const foco = Array.isArray(a.INTEREST) ? a.INTEREST : [];
  const hora = a.SCHEDULE?.EXERCISETIME;
  const h = Number(String(hora || "").split(":")[0]);
  const periodo = Number.isFinite(h) ? (h < 12 ? "Manhã" : h < 18 ? "Tarde" : "Noite") : null;

  return [
    { n: "OBJETIVO", v: OBJETIVOS[a.QUESTION_OBJECTIVE] || a.QUESTION_OBJECTIVE || "—" },
    {
      n: "META",
      v: a.TARGET_WEIGHT ? `${a.TARGET_WEIGHT} kg · ${a.TIMEFRAME || ""}`.trim() : "—",
    },
    {
      n: "TREINOS",
      v: dias.length
        ? `${dias.length}x por semana · ${dias.map((d) => nomeDoDia[d] || d).join(", ")}`
        : "—",
    },
    { n: "HORÁRIO", v: hora ? `${periodo} · ${hora}` : "—" },
    {
      n: "FOCO",
      v: foco.length ? foco.map((g) => MUSCULOS[g] || g).join(", ") : "Corpo inteiro",
    },
  ];
}

const StepConclusion = ({ answers, setCanProceed, setStepData, onAvaliacaoCorporal }) => {
  // A avaliação não acontece agora: o app ainda nem apareceu. Tocar aqui
  // AGENDA a abertura para logo depois — e o banner precisa dizer isso, ou a
  // pessoa toca, nada visível muda, e ela toca de novo.
  const [avaliacaoMarcada, setAvaliacaoMarcada] = useState(false);

  useEffect(() => {
    // O último passo é revisão, não pergunta: o CTA nasce liberado.
    setCanProceed(true);
    setStepData(null);
  }, [setCanProceed, setStepData]);

  return (
    <div className={s.fim}>
      <div className={s.card}>
        <span className={s.cardTitulo}>SEU PLANO</span>
        <div className={s.grade}>
          {resumoDoPlano(answers).map((item) => (
            <div key={item.n} className={s.celula}>
              <span className={s.celulaRotulo}>{item.n}</span>
              <span className={s.celulaValor}>{item.v}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Aviso, não pergunta: o aceite já foi dado nos Termos (seção 8). */}
      <p className={s.aviso}>
        O treino e a dieta são <strong>sugestões</strong> geradas por IA a partir
        do que você respondeu. Não substituem a avaliação de um nutricionista,
        médico ou educador físico.
      </p>

      <button
        type="button"
        className={`${s.banner} ${avaliacaoMarcada ? s.bannerMarcado : ""}`}
        aria-pressed={avaliacaoMarcada}
        onClick={() => {
          setAvaliacaoMarcada((v) => !v);
          if (!avaliacaoMarcada) onAvaliacaoCorporal?.();
        }}
      >
        <span className={s.bannerIcone} aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2" />
            <circle cx="12" cy="10" r="3" />
            <path d="M7 19a5 5 0 0 1 10 0" />
          </svg>
        </span>
        <span className={s.bannerTexto}>
          <strong>Avaliação corporal grátis</strong>
          <span>
            {avaliacaoMarcada
              ? "Combinado — abro assim que você entrar no app"
              : "Um ScanBody agora deixa a meta mais precisa"}
          </span>
        </span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>
    </div>
  );
};

export default StepConclusion;
